import { useCallback } from 'react'
import { useWeb3React } from 'lib/wagmi-compat/useWeb3React'

import { SessionType } from '@mprolab/sdk'
import { ProgressState, indexNodeStore } from 'mobxStores/IndexNodeStore'
import { useVerifyIndexNode } from './useVerifyIndexNode'

const useGetSingleAccessToken = () => {
  const { account, provider } = useWeb3React()
  const verifyIndexNode = useVerifyIndexNode()

  const obtainAccessToken = useCallback(
    async (onSuccess?: (accessToken: string) => void, onError?: (error: any) => void) => {
      try {
        const result = await verifyIndexNode({
          account,
          provider,
          successCallback: async (accessToken) => {
            if (onSuccess) {
              onSuccess(accessToken)
            } else {
              indexNodeStore.setAccessToken(accessToken)
              indexNodeStore.setProgress(ProgressState.SUCCESS)
            }
          },
          errorCallback: async (error) => {
            if (onError) onError(error)
          },
          setProgress: (progress) => indexNodeStore.setProgress(progress),
          sessionType: SessionType.SINGLE
        })
        return result
      } catch (error) {
        indexNodeStore.setProgress(ProgressState.ERROR)
        return null
      }
    },
    [account, provider]
  )

  return { obtainAccessToken }
}

export default useGetSingleAccessToken
